import React, { FC } from 'react';
import {
  useTranslations,
  withTranslationsProvider,
} from '@narvar/nth-hook-translations';
import Button from '@narvar/nth-block-button';
import { MediumHeader } from '@narvar/nth-bit-header';
import StepHeader from '../../StepHeader';

interface Props {
  next: () => void;
  featureName: string;
}

const PromptPanel: FC<Props> = ({ next, featureName }) => {
  const {
    deliveryInstructionsInitialHeaderText: headerText,
    deliveryInstructionsInitialButtonText: buttonText,
  } = useTranslations();

  return (
    <div style={{ padding: '0.25rem 0.75rem' }}>
      <StepHeader>
        <MediumHeader
          featureName={featureName}
          containerCustomStyle={{ margin: '0 0 1rem 0' }}
          as="h2"
        >
          {headerText}
        </MediumHeader>
      </StepHeader>
      <Button onClick={next}>{buttonText}</Button>
    </div>
  );
};

export default withTranslationsProvider(PromptPanel, {
  translationKeys: [
    'deliveryInstructionsInitialHeaderText',
    'deliveryInstructionsInitialButtonText',
  ],
});
